const common = {
  'nav.home': 'Strona główna',
  'nav.guide': 'Przewodnik zakupowy',
  'nav.categories': 'Kategorie',
  'nav.visitMain': 'Odwiedź stronę główną',

  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.es': 'Español',
  'lang.pl': 'Polski',

  'category.shoes': 'Buty',
  'category.hoodies': 'Bluzy i swetry',
  'category.tshirts': 'T-shirty',
  'category.jackets': 'Kurtki',
  'category.pants': 'Spodnie i szorty',
  'category.headwear': 'Nakrycia głowy',
  'category.sets': 'Zestawy',
  'category.underwear': 'Bielizna',
  'category.jersey': 'Koszulki sportowe',
  'category.accessories': 'Akcesoria',
  'category.bags': 'Torby',
  'category.belts': 'Paski',
  'category.perfumes': 'Perfumy',
  'category.other': 'Inne artykuły',

  'footer.tagline': 'Niezależne centrum zasobów USFans.',
  'footer.quickLinks': 'Szybkie linki',
  'footer.categoriesTitle': 'Kategorie',
  'footer.legal': 'Informacje prawne',
  'footer.disclaimerTitle': 'Zastrzeżenie',
  'footer.disclaimerText': 'USFansLink to niezależne źródło informacji. Nie gwarantujemy dokładności, bezpieczeństwa ani wiarygodności każdego sprzedawcy, linku, wpisu w arkuszu, kuponu ani kodu rabatowego. Zawsze weryfikuj informacje samodzielnie.',
  'footer.rights': 'Wszelkie prawa zastrzeżone.',
};

export default common;